import script from "./BaseComponent.vue?vue&type=script&lang=ts"
export * from "./BaseComponent.vue?vue&type=script&lang=ts"

const __exports__ = script;

export default __exports__